import { render, staticRenderFns } from "./AuthorizationItems.vue?vue&type=template&id=41ad36d2"
import script from "./AuthorizationItems.vue?vue&type=script&lang=js"
export * from "./AuthorizationItems.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationItems.vue?vue&type=style&index=0&id=41ad36d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports